import React, { useEffect } from "react";
import DinningCard from "../components/Dinning/DinningCard";
import DinningDetails from "../components/Dinning/DinningDetails";
import FoodMenu from "../components/Dinning/FoodMenu";
import { useAppDispatch, useAppSelector } from "../Hooks";
import { getDinningData } from "../features/Dinning";
import { Loader } from "../components/common/Loader";
import { Banner } from "../components/common/Banner";


const Dinning: React.FC<{ banner_title: string }> = ({ banner_title }) => {
    const dispatch = useAppDispatch();
    const { dinning_details, dinning_ameniti, trending_menu, trending_menu_image, dinningLoader, status } = useAppSelector(state => state.dinning);
    const { menu } = useAppSelector(state => state.menuAccess);
    const { dinning_sections } = menu?.dinning || {};
    useEffect(() => {
        dispatch(getDinningData());
    }, [status, dispatch]);

    if (dinningLoader) {
        return <Loader />;
    }
    return (
        <>
            <Banner banner_title={banner_title} />
            {
                dinning_sections && dinning_sections?.dinning_card &&

                <DinningCard dinning_ameniti={dinning_ameniti} />
            }
            {

                dinning_sections && dinning_sections?.dinning_details &&

                <DinningDetails dinning_details={dinning_details} />
            }
            {
                dinning_sections && dinning_sections?.food_menu &&

                <FoodMenu trending_menu={trending_menu} trending_menu_image={trending_menu_image} />
            }
        </>
    )
}
export default Dinning;